import React, {useContext} from 'react';
import '../../polyfill/urlsearchparams.es5';
import {useDispatch} from 'react-redux';
import {TertiaryButton} from '@bonprix/design-system';
import {openFilter} from '../FilterSlice.jsx';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {Constants} from '../view-constants';
import {useTrinity} from '../hooks/use-trinity.js';
import Landmark from '@core/scripts/components/landmark-adapter';

export default function FilterOrderingButton({filterViewValue}) {
    const {texts, shopId} = useContext(articleOverviewStaticContext);
    const {sendFilterView, sendClickBasic} = useTrinity();

    const dispatch = useDispatch();

    const open = () => {
        dispatch(openFilter());
        sendClickBasic('open_filter_sorting', Constants.FILTER_VIEW_EVENT_VERSION);

        if (filterViewValue) {
            sendFilterView('filter_layer', filterViewValue, Constants.FILTER_VIEW_EVENT_VERSION);
            const landmarkData = {
                filter_view: filterViewValue,
                filter_view_shopId: shopId.current,
            };
            Landmark.sendActionLandmark(landmarkData);
        }
    };

    return (
        <TertiaryButton
            iconPosition="start"
            onClick={open}
            small={true}
            type={'button'}
            icon="control-panel"
            contentWidth={true}
        >
            {texts.filter_title}
        </TertiaryButton>
    );
}
